module.exports = __webpack_public_path__ + "img/b89909847bda44b30f7d2c18d68b186f.de8d854b.png";